import { memo } from 'react';
import { Col, Row } from 'react-bootstrap';

const DoneOverlay = ({ bIsDone, doneOverlayContent }) => {
    return (
        bIsDone &&
        <div className='spinner-overlay'>
            <Row className='g-0'>
                <Col className='text-center'>
                    <div className='icon-64 icon-done icon-primary'></div>
                    <div className='font-regular font-size12 color-text break-line'>{doneOverlayContent}</div>
                </Col>
            </Row>
        </div>

    );
};

export default memo(DoneOverlay);
